export class ContentApiError extends Error {
	public statusCode: number;

	constructor({ name, query, error, cause }: { name: string; query: string; error; cause }) {
		super(...error);

		// Set the prototype explicitly, this is required in some environments like Babel
		Object.setPrototypeOf(this, ContentApiError.prototype);

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, ContentApiError);
		}

		const errorMessage: string = error
			.map((errorItem) => {
				const { message, path, locations } = errorItem ?? {};
				return `${message} Path: ${path?.join(', ')}. Line: ${locations?.[0]?.line}. Query: \r\n${query
					.split('\n')
					.map((line, index) => `${index + 1}: ${line}`)
					.join('\n')}`;
			})
			.join('\r\n');

		this.name = name;
		this.cause = cause;
		this.statusCode = error?.response?.status;
		const requestUrl = error?.config?.url;
		const requestUrlMessage = !requestUrl ? '' : `. Request url: ${requestUrl}`;
		this.message = errorMessage + requestUrlMessage;
	}
}
